/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import dynamic from "next/dynamic";
import styled from "styled-components";

import { CodeBlock } from "src/classes/block/block-types";
import { StyledCodeBlockContent, codeEditorStyles } from "src/components/Block/BlockTypes/CodeBlock/styles";
import { NoSSR } from "src/components/UI/NoSSR/NoSSR";

// TODO: replace with a high quality package
const CodeEditor = dynamic(() => import("@uiw/react-textarea-code-editor").then((mod) => mod.default) as any, {
  ssr: false,
}) as any;

interface Props {
  block: CodeBlock;
}

export const SCodeBlock = ({ block }: Props) => {
  return (
    <NoSSR>
      <StyledCodeBlockContent>
        <CodeEditor
          className="CodeEditor"
          id={block.codeEitorId}
          value={block.snapshot.plainText}
          placeholder="Enter some code"
          language={block.snapshot.language}
          padding={25}
          readOnly={true}
          style={codeEditorStyles}
        />
        <StyledLanguage>{block.snapshot.language}</StyledLanguage>
      </StyledCodeBlockContent>
    </NoSSR>
  );
};

const StyledLanguage = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  color: #aeaeae;
  font-family: "IBM Plex Mono";
  font-size: 12px;
  padding: 5px;
`;
